import ReactGA from 'react-ga';
import { isBotTraffic } from './checkBrowser';

const isProdSite = process.env.REACT_APP_NODE_ENV === 'production';
const hasWindow = typeof window !== 'undefined';
const ua = hasWindow ? navigator.userAgent : '';
const isOrganic = isProdSite && !isBotTraffic(ua);

const gtagEvent = (name, params) => {
  window?.gtag('event', name, {
    send_to: 'GA4',
    params
  });
};

const sendGAEvent = info => {
  if (isOrganic) {
    ReactGA.event(info);
    if (info.ga4Event) {
      gtagEvent(info.ga4Event, info);
    } else {
      gtagEvent(info.action, info);
    }
  }
};

/** sendEcEvent 發送 GA 增強型電子商務 Event 事件
 * @param {String} eventName Event 名稱字串
 * @param {Object} data 要隨 Event 一起送出的資料
 */
const sendEcEvent = (eventName, data) => {
  if (isOrganic) {
    if (data) {
      ReactGA.plugin.execute('ec', eventName, data);
      const dat = data;
      dat.category = 'ec';
      gtagEvent(eventName, dat);
    } else {
      ReactGA.plugin.execute('ec', eventName);
      gtagEvent(eventName, { category: 'ec' });
    }
  }
};

/** sendEcAction 發送 GA 增強型電子商務 Action 事件
 * @param {String} actionName Action 名稱字串
 * @param {Object} data 要隨 Action 一起送出的資料
 */
const sendEcAction = (actionName, data) => {
  if (isOrganic) {
    if (data) {
      ReactGA.plugin.execute('ec', 'setAction', actionName, data);
      const d = data;
      d.category = 'ec';
      gtagEvent(actionName, data);
    } else {
      ReactGA.plugin.execute('ec', 'setAction', actionName);
      gtagEvent(actionName, { category: 'ec' });
    }
  }
};

/** sendEcStep 發送 GA 增強型電子商務 checkout Event 事件
 * @param {Number} step 步驟、表明目前是第幾步驟的數值
 * @param {Object} data 要隨 checkout Event 一起送出的資料
 */
const sendEcStepEvent = (step, data) => {
  if (isOrganic) {
    const newData = {
      ...data,
      step
    };
    sendEcAction('checkout', newData);
    gtagEvent('checkout', newData);
  }
};

/**
 * sendGAEc 包含 GA 增強型電子商務所需 method 之物件
 * @property {sendEcStepEvent}
 * @property {sendEcStepEvent}
 * @property {sendEcAction}
 * @see https://github.com/react-ga/react-ga
 * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce?hl=zh-cn
 */
const sendGAEc = {
  event: sendEcEvent,
  action: sendEcAction,
  step: sendEcStepEvent
};

export { sendGAEvent, sendGAEc };
